











































































































































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LineChart from '@/components/Shared/LineChart.vue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatPercent, formatNumber, formatHours, formatDays, formatChangePercent } from '@/lib/reportFormatters';
import { ReportMetric } from '@/models/Reports/ManagementReportModels';

@Component({ name: 'TempOpsReports', components: { LineChart } })
export default class TempOpsReports extends GiganautVue {

  get workerLabel(): string { return this.Labels.worker || 'Worker'; }
  get workersLabel(): string { return this.Labels.workers || 'Workers'; }
  get companyLabel(): string { return this.Labels.company || 'Company'; }
  get locationsLabel(): string { return this.Labels.locations || 'Locations'; }

  fillRateHeaders = [
    { text: 'Name', value: 'label' },
    { text: 'Required', value: 'required', align: 'end' },
    { text: 'Filled', value: 'filled', align: 'end' },
    { text: 'Fill Rate', value: 'fillRate', align: 'end' },
  ];

  reasonHeaders = [
    { text: 'Reason', value: 'label' },
    { text: 'Count', value: 'value', align: 'end' },
  ];

  get cancellationCompanyHeaders() {
    return [
      { text: this.companyLabel, value: 'label' },
      { text: 'Cancellations', value: 'cancellations', align: 'end' },
      { text: 'Rate', value: 'rate', align: 'end' },
    ];
  }

  get deploymentHeaders() {
    return [
      { text: this.workerLabel, value: 'workerName' },
      { text: 'Shifts', value: 'shifts', align: 'end' },
      { text: 'Hours', value: 'hours', align: 'end' },
      { text: this.locationsLabel, value: 'locations', align: 'end' },
    ];
  }

  get bookingVolume() { return ManagementReportsModule.bookingVolume; }
  get fillRate() { return ManagementReportsModule.fillRate; }
  get cancellations() { return ManagementReportsModule.cancellations; }
  get workerDeployment() { return ManagementReportsModule.workerDeployment; }
  get timesheetApproval() { return ManagementReportsModule.timesheetApproval; }

  get bookingVolumeMetrics() {
    const s = this.bookingVolume;
    if (!s) return [];
    return [
      this.buildMetric(s.bookingsCreated, 'number'),
      this.buildMetric(s.shiftsCreated, 'number'),
      this.buildMetric(s.totalHours, 'number'),
    ];
  }

  get bookingTrendChart() {
    const trend = this.bookingVolume ? this.bookingVolume.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [
        {
          label: 'Bookings',
          borderColor: '#3f51b5',
          backgroundColor: 'rgba(63,81,181,0.1)',
          data: trend.map(t => t.bookings),
          fill: true,
        },
        {
          label: 'Shifts',
          borderColor: '#ff5c00',
          backgroundColor: 'rgba(255,92,0,0.1)',
          data: trend.map(t => t.shifts),
          fill: true,
        },
      ],
    };
  }

  get numberChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            callback: (value: any) => formatNumber(value),
          },
        }],
      },
    };
  }

  buildMetric(m: ReportMetric, type: string) {
    let formatted = '';
    if (type === 'currency') formatted = formatCurrency(m.value);
    else if (type === 'percent') formatted = formatPercent(m.value);
    else formatted = formatNumber(m.value);
    return { label: m.label, formatted, changePercent: m.changePercent };
  }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
  fmtHours(v: number) { return formatHours(v); }
  fmtDays(v: number) { return formatDays(v); }
  fmtChange(v: number) { return formatChangePercent(v); }
}
